import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import MultiSelectDropdown from 'components/MultiSelectDropdown';
import { fetchAllCategories, searchItems } from '../../../services/api/inventoryItems';
import { showError } from '../../../utils/notifications';
import { sortArray } from 'utils';
import SearchBar from 'components/Autosuggest/Autosuggest';

const InventoryItemsFilters = props => {
  const [itemId, setItemId] = useState<string>('');
  const [item, setItem] = useState<Record<string, any>>({});
  const [categoryIds, setCategoryIds] = useState<any[]>([]);
  const [categories, setCategories] = useState<{ label: string; value: string }[]>([]);
  
  const fetchAllCategoriesFn = async () => {
    try {
      const response = await fetchAllCategories();
      setCategories(response.map(cat => ({ label: cat.description, value: cat.objectId })));
    } catch (e) {
      showError(e);
    }
  };

  useEffect(() => {
    fetchAllCategoriesFn();
  }, []);

  const resetFilter = () => {
    setItemId('');
    setItem({});
    setCategoryIds([]);
    props.onSubmit({});
  };

  const handleSubmit = () => {
    const filterData: Record<string, any> = {};
    if(categoryIds?.length > 0){
      filterData.categoryIds = categoryIds.map(cat => cat.value);
    }
    if(itemId){
      filterData.inventoryItemId = itemId;
    }
    props.onSubmit(filterData);
  };

  const handleSuggestionClick = (suggestion: Record<string, any>) => {
    const item: Record<string, any> = {};
    item.id = suggestion.id;
    item.name = suggestion.displayName;
    setItem(item);
    setItemId(item.id);
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['autosuggest-group']}>
        <div className={styles['label']}>Inventory Item</div>
        <div className={styles['autosuggest-input']}>
          <SearchBar
            value={item.name || ''}
            setValue={value => setItem({ ...item, name: value })}
            searchAPI={searchItems}
            searchAPIParamKey={'term'}
            onSuggestionClicked={handleSuggestionClick}
          />
        </div>
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Inventory Item ID</div>
        <input
          className={'form-control'}
          value={itemId}
          onChange={e => setItemId(e.target.value)}
        />
      </div>
      <div className={`${styles['input-group']} ${styles['category-group']}`}>
        <div className={styles['label']}>Category</div>
        <MultiSelectDropdown
          value={categoryIds}
          options={sortArray(categories, 'label')}
          onChange={setCategoryIds}
          disableSearch={true}
        />
      </div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default InventoryItemsFilters;